/**
 * Read Nest-style `{ statusCode, message, code?, details? }` payloads off axios errors.
 * `message` may be a string or a ValidationPipe string[].
 */

const isRecord = (value: unknown): value is Record<string, unknown> =>
    value != null && typeof value === 'object' && !Array.isArray(value)

const getResponseData = (e: unknown): Record<string, unknown> | undefined => {
    if (!isRecord(e) || !isRecord(e.response)) {
        return undefined
    }
    return isRecord(e.response.data) ? e.response.data : undefined
}

export const getApiErrorMessage = (e: unknown, fallback = 'Unknown error'): string => {
    const data = getResponseData(e)
    const message = data?.message
    if (typeof message === 'string' && message !== '') {
        return message
    }
    if (Array.isArray(message)) {
        const joined = message.filter((item): item is string => typeof item === 'string' && item !== '').join(' ')
        if (joined !== '') {
            return joined
        }
    }
    return fallback
}

export const getApiErrorCode = (e: unknown): string | undefined => {
    const code = getResponseData(e)?.code
    return typeof code === 'string' && code !== '' ? code : undefined
}

export const getApiErrorDetails = (e: unknown): Record<string, unknown> | undefined => {
    const details = getResponseData(e)?.details
    return isRecord(details) ? details : undefined
}

export const hasApiErrorResponse = (e: unknown): boolean => getResponseData(e) != null
